import { Service } from '../../service.model';

export interface EntMaintenanceService {
  id: number;
  oid: string;
  subtype: string;
  name: string;
  description: string;
  titleFr: string;
  titleDe: string;
  descriptionDe: string;
  descriptionFr: string;
  helpFr: string | null;
  helpDe: string | null;
  subtitleFr: string;
  subtitleDe: string;
  accessurlFr: string;
  accessurlDe: string;
  url: string | null;
  jpegPhoto: string;
  priority: number;
  roles: string;
}

export const toService = (entService: EntMaintenanceService): Service => {
  return {
    oid: entService.oid,
    accessurl_de: entService.accessurlDe,
    accessurl_fr: entService.accessurlFr,
    description: entService.description,
    description_de: entService.descriptionDe,
    description_fr: entService.descriptionFr,
    help_de: entService.helpDe,
    help_fr: entService.helpFr,
    jpegPhoto: entService.jpegPhoto,
    name: entService.name,
    priority: entService.priority,
    subtitle_de: entService.subtitleDe,
    subtitle_fr: entService.subtitleFr,
    subtype: [entService.subtype],
    title_de: entService.titleDe,
    title_fr: entService.titleFr,
    url: entService.url,
    roles: entService.roles.split(','),
  };
};
